import { useMemo } from "react";
import Fuse from "fuse.js";
const FUSE_DEFAULTS = {
    threshold: 0.4,
    minMatchCharLength: 2,
    includeScore: true,
    includeMatches: true
};
export function useEntityFuzzySearch({ items, query, keys }) {
    const fuse = useMemo(()=>new Fuse(items, {
            keys: keys,
            ...FUSE_DEFAULTS
        }), [
        items,
        keys
    ]);
    return useMemo(()=>{
        const trimmed = query.trim();
        if (!trimmed) {
            return {
                results: items.map((item)=>({
                        item
                    }))
            };
        }
        const words = trimmed.split(/\s+/).filter((w)=>w.length >= 2);
        if (words.length <= 1) {
            const raw = fuse.search(trimmed);
            return {
                results: raw.map((r)=>({
                        item: r.item,
                        score: r.score,
                        matches: r.matches
                    }))
            };
        }
        const counter = new Map();
        for (const word of words){
            for (const r of fuse.search(word)){
                const entry = counter.get(r.item);
                if (entry) {
                    entry.matchCount += 1;
                    entry.totalScore += r.score ?? 0;
                    if (r.matches) entry.matches.push(...r.matches);
                } else {
                    counter.set(r.item, {
                        matchCount: 1,
                        totalScore: r.score ?? 0,
                        matches: r.matches ? [
                            ...r.matches
                        ] : []
                    });
                }
            }
        }
        return {
            results: [
                ...counter.entries()
            ].sort((a, b)=>{
                if (b[1].matchCount !== a[1].matchCount) {
                    return b[1].matchCount - a[1].matchCount;
                }
                return a[1].totalScore / a[1].matchCount - b[1].totalScore / b[1].matchCount;
            }).map(([item, meta])=>({
                    item,
                    score: meta.totalScore / meta.matchCount,
                    matches: meta.matches
                }))
        };
    }, [
        fuse,
        items,
        query
    ]);
}

//# sourceMappingURL=useEntityFuzzySearch.js.map